import { Box, List } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import { CSSObject, Theme, styled } from "@mui/material/styles";
import React from "react";
import DelendLink from "./DelendLink";

import { Profile } from "../../@types/profile";
import { useAppSelector } from "../../hooks/hooks";
import {
  DelendAssignmentTurnedInOutlined,
  DelendCurrencyExchange,
  DelendKeyboardDoubleArrowLeft,
  DelendMenuOpen,
  DelendReceiptLong,
} from "../Vectors/Icons";

const defaultWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
  width: defaultWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(6)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: defaultWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

interface MenuOptionsProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const MenuOptions: React.FC<MenuOptionsProps> = ({ open, setOpen }) => {
  const handleMenu = () => {
    setOpen(!open);
  };

  return (
    <React.Fragment>
      <List>
        <Box
          style={{
            textAlign: open ? "right" : "center",
            paddingRight: open ? "12px" : 0,
            paddingTop: "8px",
            paddingBottom: "8px",
          }}
          onClick={handleMenu}
        >
    
            {open ? (
              <DelendKeyboardDoubleArrowLeft
                style={{ color: "#8087A6", cursor: "pointer" }}
              />
            ) : (
              <DelendMenuOpen
                style={{
                  color: "#8087A6",
                  cursor: "pointer",
                  transform: "rotateZ(180deg)",
                  marginLeft: "-7px",
                }}
              />
            )}
        </Box>

        <DelendLink
          to="receivable"
          icon={<DelendReceiptLong />}
          text="Gestão de vendas"
          showTooltip={!open}
        />

        {/* <DelendLink
          to="consents"
          icon={<InventoryOutlined />}
          text="Clientes"
          showTooltip={!open}
        /> */}

        <DelendLink
          to="anticipation"
          icon={<DelendCurrencyExchange />}
          text="Antecipações contratadas"
          showTooltip={!open}
        />

        <DelendLink
          to="consents"
          icon={<DelendAssignmentTurnedInOutlined />}
          text="Open Finance"
          showTooltip={!open}
        />
      </List>
    </React.Fragment>
  );
};

const DrawerHeader = styled("div")(({ theme }) => {
  const profile = useAppSelector<Profile | undefined>(
    (state) => state.profileSlice.profile
  );

  return {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(profile && !profile.email_verified ? 8 : 0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  };
});

const DelendAsideAppBar = () => {
  const [open, setOpen] = React.useState(true);

  return (
    <Drawer open={open} variant="permanent">
      <DrawerHeader />

      <MenuOptions open={open} setOpen={setOpen} />
    </Drawer>
  );
};

export default DelendAsideAppBar;
